import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material";

@Component({
  selector: "alert-dialog",
  templateUrl: "./alert-dialog.component.html",
  styleUrls: ["./alert-dialog.component.scss"]
})
export class AlertDialogComponent {
  constructor(public dialogRef: MatDialogRef<AlertDialogComponent>) {}

  public alertMessage: string;
  public title: string;

  close() {
    this.dialogRef.close();
  }
}
